import React from 'react';
import { Box } from '@mui/material';

interface Props {
    status: string | null;
    details: string | null;
}

export const SyncStatusSummary = ({ status, details }: Props) => {
    if (!status) {
        return null;
    }

    return (
        <Box display="flex" gap={4} alignItems="center" my={2}>
            <Box display="flex" gap={1}>
                <strong>Status:</strong>
                <p
                    style={{
                        color: status === 'failed' ? 'red' : status === 'completed' ? 'green' : 'black',
                        fontWeight: 'bold',
                    }}
                >
                    {status}
                </p>
            </Box>
            {details && (
                <Box>
                    <strong>Details:</strong> {details}
                </Box>
            )}
        </Box>
    );
};
